const translations: Record<string, Record<string, string>> = {
  en: {
    'navbarfooter.termsuse': 'Terms of Use',
    'navbarfooter.serviceagreement': 'Service Agreement',
    'navbarfooter.privacypolicy': 'Privacy Policy',
    'navbarfooter.cookiespolicy': 'Cookies Policy',
    'navbarfooter.cookieSettings': 'Cookie Settings',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Enter your email',
    'register.emailInputTitle': 'Email address',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Create account',
    'actions.back': 'Back',
    'actions.next': 'Next',

    'register.checkEmail':
      'You will receive an email from us soon. Go to your mail account and click on the confirmation link to continue.',
    'register.checkSpam2': "If you don't receive the confirmation email, please check your spam folder",
    'register.welcomeTo': 'Welcome to',
    'register.registerSuccess':
      'Your account has now been created. Please note that this does not include product registration for warranty purposes.',
  },
  es: {
    'navbarfooter.termsuse': 'Condiciones de uso',
    'navbarfooter.serviceagreement': 'Acuerdo de servicio',
    'navbarfooter.privacypolicy': 'Política de privacidad',
    'navbarfooter.cookiespolicy': 'Política de cookies',
    'navbarfooter.cookieSettings': 'Configuración de cookies',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Introduce tu correo electrónico',
    'register.emailInputTitle': 'Dirección de correo',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Crear cuenta',
    'actions.back': 'Volver',
    'actions.next': 'Siguiente',

    'register.checkEmail':
      'Pronto recibirás un correo electrónico nuestro. Ve a tu cuenta de correo y haz clic en el enlace de confirmación para continuar.',
    'register.checkSpam2': 'Si no recibes el correo de confirmación, por favor revisa tu carpeta de spam.',
    'register.welcomeTo': 'Bienvenido a',
    'register.registerSuccess':
      'Su cuenta ha sido creada. Tenga en cuenta que esto no incluye el registro del producto a efectos de garantía.',
  },
  pt: {
    'navbarfooter.termsuse': 'Termos de uso',
    'navbarfooter.serviceagreement': 'Contrato de serviço',
    'navbarfooter.privacypolicy': 'Política de privacidade',
    'navbarfooter.cookiespolicy': 'Política de cookies',
    'navbarfooter.cookieSettings': 'Configuração de cookies',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Insira o seu e-mail',
    'register.emailInputTitle': 'Endereço de e-mail',
    'register.emailInputPlaceHolder': 'Endereço de e-mail',
    'register.createAccount': 'Criar conta',
    'actions.back': 'Voltar',
    'actions.next': 'Seguinte',

    'register.checkEmail':
      'Vamos enviar-lhe um e-mail. Verifique a sua conta de e-mail e clique no link de confirmaçao para continuar.',
    'register.checkSpam2': 'Se não receber o email de confirmaçao, por favor verifique a sua caixa de spam.',
    'register.welcomeTo': 'Bem vindo à',
    'register.registerSuccess':
      'A sua conta foi agora criada. Por favor, note que isto não inclui o registo do produto para fins de garantia.',
  },
  it: {
    'navbarfooter.termsuse': 'Termini di utilizzo',
    'navbarfooter.serviceagreement': 'Accordo di servizio',
    'navbarfooter.privacypolicy': 'Informativa sulla privacy',
    'navbarfooter.cookiespolicy': 'Informativa sui cookie',
    'navbarfooter.cookieSettings': 'Impostazioni cookie',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Inserisci la tua email',
    'register.emailInputTitle': 'Indirizzo email',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Crea account',
    'actions.back': 'Indietro',
    'actions.next': 'Avanti',

    'register.checkEmail':
      "Riceverai presto un'email da parte nostra. Vai alla tua casella di posta e clicca sul link di conferma per continuare.",
    'register.checkSpam2': "Se non ricevi l'email di conferma, controlla la cartella dello spam.",
    'register.welcomeTo': 'Benvenuto a',
    'register.registerSuccess':
      'Il tuo account è stato creato. Si prega di notare che questo non include la registrazione del prodotto ai fini della garanzia.',
  },
  fr: {
    'navbarfooter.termsuse': "Conditions d'utilisation",
    'navbarfooter.serviceagreement': 'Contrat de service',
    'navbarfooter.privacypolicy': 'Politique de confidentialité',
    'navbarfooter.cookiespolicy': 'Politique de cookies',
    'navbarfooter.cookieSettings': 'Paramètres des cookies',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Entrez votre email',
    'register.emailInputTitle': 'Adresse e-mail',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Créer un compte',
    'actions.back': 'Retour',
    'actions.next': 'Suivant',

    'register.checkEmail':
      'Vous recevrez bientôt un e-mail de notre part. Accédez à votre messagerie et cliquez sur le lien de confirmation pour continuer.',
    'register.checkSpam2': "Si vous ne recevez pas l'e-mail de confirmation, veuillez vérifier votre dossier de spam.",
    'register.welcomeTo': 'Bienvenue à',
    'register.registerSuccess':
      "Votre compte est maintenant créé. Veuillez noter que cela n'inclut pas l'enregistrement du produit à des fins de garantie.",
  },
  de: {
    'navbarfooter.termsuse': 'Nutzungsbedingungen',
    'navbarfooter.serviceagreement': 'Servicevereinbarung',
    'navbarfooter.privacypolicy': 'Datenschutzrichtlinie',
    'navbarfooter.cookiespolicy': 'Cookie-Richtlinie',
    'navbarfooter.cookieSettings': 'Cookie-Einstellungen',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Geben Sie Ihre E-Mail-Adresse ein',
    'register.emailInputTitle': 'E-Mail-Adresse',
    'register.emailInputPlaceHolder': 'E-Mail eingeben',
    'register.createAccount': 'Konto erstellen',
    'actions.back': 'Zurück',
    'actions.next': 'Weiter',

    'register.checkEmail':
      'Sie erhalten in Kürze eine E-Mail von uns. Gehen Sie zu Ihrem E-Mail-Konto und klicken Sie auf den Bestätigungslink, um fortzufahren.',
    'register.checkSpam2': 'Wenn Sie die Bestätigungs-E-Mail nicht erhalten, überprüfen Sie bitte Ihren Spam-Ordner.',
    'register.welcomeTo': 'Willkommen bei',
    'register.registerSuccess':
      'Ihr Account wurde nun erstellt. Bitte beachten Sie, dass dies keine Produktregistration für Garantiezwecke beinhaltet.',
  },
};

const allLanguages = ['en', 'es', 'pt', 'it', 'fr', 'de'];
const laufenLanguages = allLanguages;
const rocaLanguages = ['en', 'es'];

export const translate = (key: string, langOverride?: string, brandCode?: number | string): string => {
  const brandLangs = brandCode === 14 ? rocaLanguages : brandCode === 11 ? laufenLanguages : allLanguages;

  const rawLang = langOverride?.toLowerCase() || navigator.language?.split('-')[0]?.toLowerCase() || 'en';
  const finalLang = brandLangs.includes(rawLang) ? rawLang : 'en';

  return translations[finalLang]?.[key] ?? key;
};
